import {numberText} from "../public/js/utils/sanitize.js";
import {PlayingCard} from "./PlayingCard.jsx";
import {useTick} from "./useGame.js";

// A mini-game on the phone: your own Blackjack hand with Ta kort and Stanna and the
// others' hands under it, the winner's pick of who drinks, or the ballot. Every word,
// card and enabled button is controller.minigamePanel()'s; this paints it and ticks the
// countdown. A finished game's result is the only part a tap puts away, and the
// controller is what knows that.
export function MinigamePanel({controller}) {
  const panel = controller.minigamePanel();
  useTick(Boolean(panel));
  if (!panel) return null;

  return (
    <section
      className={`minigame-panel kind-${panel.kind} phase-${panel.phase}`}
      aria-label={panel.title}
      onClick={() => controller.dismissMinigamePanel()}
    >
      <div className="minigame-dialog">
        <header className="minigame-head">
          <h2>{panel.title}</h2>
          {panel.seconds !== null && (
            <span className={panel.urgent ? "minigame-clock urgent" : "minigame-clock"} role="timer">
              <span aria-hidden="true">⏱</span> {numberText(panel.seconds)} s
            </span>
          )}
        </header>
        {panel.roundNote && <p className="minigame-round">{panel.roundNote}</p>}
        {panel.prompt && <p className="minigame-prompt">{panel.prompt}</p>}

        {panel.hand && (
          <div className={`minigame-hand status-${panel.hand.status}`}>
            <div className="playing-cards">
              {panel.hand.cards.map((card, index) => <PlayingCard key={`${card.code}-${index}`} card={card} />)}
            </div>
            <strong className="minigame-total">{panel.hand.statusText}</strong>
          </div>
        )}
        {(panel.canHit || panel.canStand) && (
          <div className="minigame-actions">
            <button className="o-btn ghost" type="button" disabled={!panel.canStand} onClick={() => controller.minigameStand()}>
              Stanna
            </button>
            <button className="o-btn primary" type="button" disabled={!panel.canHit} onClick={() => controller.minigameHit()}>
              Ta kort
            </button>
          </div>
        )}

        {panel.targets?.length > 0 && (
          <div className="minigame-targets">
            {panel.targets.map((target) => (
              <button
                key={target.id}
                className={target.chosen ? "minigame-target chosen" : "minigame-target"}
                type="button"
                aria-pressed={target.chosen}
                onClick={() => controller.minigamePick(target.id)}
              >
                <span className="avatar" style={{"--seat-color": target.color}}>
                  <span aria-hidden="true">{target.icon}</span>
                </span>
                <strong>{target.name}</strong>
              </button>
            ))}
          </div>
        )}

        <p className="minigame-note">{panel.note}</p>
        {panel.personal && <p className="minigame-personal">{panel.personal}</p>}

        {panel.rows?.length > 0 && (
          <ul className="minigame-rows">
            {panel.rows.map((row) => (
              <li
                key={row.id}
                className={`minigame-row status-${row.status}${row.winner ? " winner" : ""}`}
                style={{"--seat-color": row.color}}
              >
                <span className="avatar"><span aria-hidden="true">{row.icon}</span></span>
                <span className="minigame-row-name">{row.name}</span>
                <span className="playing-cards small">
                  {row.cards.map((card, index) => <PlayingCard key={`${card.code}-${index}`} card={card} />)}
                </span>
                <span className="minigame-row-status">{row.statusText}</span>
              </li>
            ))}
          </ul>
        )}
        {panel.phase === "done" && <span className="minigame-hint">Tryck för att stänga</span>}
      </div>
    </section>
  );
}
